import React from 'react';
import { BannerAction } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';

import { FPSPhoneNumbers } from '../../shared/Content';

const CallUsModal = () => {
    return (
        <BannerAction
            id={'banner-call-us'}
            title={'Call us'}
            text={'Get technical support or help navigating this Retirement Advisory Service tool.'}
            phoneNumber={FPSPhoneNumbers.serviceErrorNumber}
        />
    )
};

export default CallUsModal;